/**
 * @file commin-mutations
 */

import topicFilterActions from './topicFilter';
import getListActions from './getList';
import passMkdActions from './passMkd';

export default {
    ...topicFilterActions,
    ...getListActions,
    ...passMkdActions
};
